var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDmanyGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 60,
    viewBox: "0 0 167 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -650,
    y: 0,
    width: 2795,
    height: 60
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 155,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 6H6V54H161V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.808 6.02051V43.2231H26.066V40.7264C24.363 42.7448 21.834 43.9677 18.375 43.9677C11.613 43.9677 6.039 37.8617 6.039 29.9374C6.039 22.0132 11.613 15.9055 18.375 15.9055C21.834 15.9055 24.363 17.1283 26.066 19.1484V6.02051H33.808ZM26.066 29.9357C26.066 25.9499 23.485 23.4515 19.923 23.4515C16.362 23.4515 13.781 25.9499 13.781 29.9357C13.781 33.9216 16.362 36.42 19.923 36.42C23.485 36.42 26.066 33.9284 26.066 29.9357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.977 26.9118V43.2267H68.235V27.6021C68.235 24.9443 66.996 23.2448 64.519 23.2448C61.938 23.2448 60.493 25.1105 60.493 28.2399V43.2267H52.752V27.6021C52.752 24.9443 51.511 23.2448 49.034 23.2448C46.454 23.2448 45.008 25.1105 45.008 28.2399V43.2267H37.266V16.6538H45.008V19.0979C46.196 17.2915 48.467 15.9092 51.926 15.9092C54.972 15.9092 57.243 17.1846 58.688 19.4167C60.133 17.2915 62.508 15.9092 66.173 15.9092C72.106 15.9092 75.977 20.2665 75.977 26.9118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.554 16.6538V43.2267H97.812V40.73C96.109 42.7484 93.579 43.9713 90.122 43.9713C83.368 43.9713 77.786 37.8653 77.786 29.9411C77.786 22.0169 83.36 15.9092 90.122 15.9092C93.581 15.9092 96.109 17.1321 97.812 19.1521V16.6538H105.554ZM97.812 29.9411C97.812 25.9552 95.231 23.4568 91.67 23.4568C88.109 23.4568 85.528 25.9552 85.528 29.9411C85.528 33.9269 88.109 36.4253 91.67 36.4253C95.231 36.4253 97.812 33.9269 97.812 29.9343V29.9411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.788 26.9118V43.2267H126.046V28.0804C126.046 24.7849 124.032 23.2448 121.555 23.2448C118.717 23.2448 116.755 24.9409 116.755 28.7182V43.2267H109.013V16.6538H116.755V19.1521C118.148 17.1846 120.729 15.9092 124.136 15.9092C129.349 15.9092 133.788 19.7356 133.788 26.9118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.886 16.6572L152.061 42.4381C149.17 50.8882 144.576 54.2363 137.35 53.8649V46.424C140.963 46.424 142.667 45.2537 143.802 42.0141L133.531 16.6623H142.054L147.783 32.9246L152.635 16.6623L160.886 16.6572Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2807 -9H-650V86H2807V-9Z",
    fill: "#ADADAD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmanyGrey);
export default __webpack_public_path__ + "static/media/Dmany-grey.1a6a60acd1bc268eb888842f3b2976bb.svg";
export { ForwardRef as ReactComponent };